module.exports = __webpack_public_path__ + "static/media/Eyeball Icon.f30a51f2.jpeg";